<template>
  <!-- 首页 -->
  <div class="home">
    <!-- 顶部导航栏 -->
    <TopNav></TopNav>
    <!-- 首页轮播图 -->
    <HomeBanner></HomeBanner>
    <!-- 产品体系 -->
    <System></System>
    <!-- 智能硬件系统 -->
    <Hardware></Hardware>
    <!-- 丰富的软件设备 -->
    <Software></Software>
    <!-- 我们服务的客户 -->
    <Customer></Customer>
    <!-- 最新资讯 -->
    <Dynamic></Dynamic>

    <div class="logo-position">
      <img class="experienceLogo" :src="experienceLogo" alt="" />
      <div class="logo-absolute">
        <div class="text">
          畅月数字家园致力于移动互联网、物联网、智能设备、云计算等新技术,建立开放生态技术平台，持续提升智慧社区服务效率，建立智慧社区,实现管理透明化、服务智能化、决策数据化、平台生态化、流程工具化，让客户更满意，让员工更愉悦......
        </div>
        <div class="click" @click="experienceClick">立即体验</div>
      </div>
    </div>

    <div class="header">
      <div class="title">一站式服务</div>
      <div class="border"></div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNav></BottomNav>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/pc/components/TopNav.vue";
import BottomNav from "../../../components/pc/components/BottomNav.vue";
import HomeBanner from "../../../components/pc/Home/HomeBanner.vue";
import System from "../../../components/pc/Home/System.vue";
import Hardware from "../../../components/pc/Home/Hardware.vue";
import Software from "../../../components/pc/Home/Software.vue";
import Customer from "../../../components/pc/Home/Customer.vue";
import Dynamic from "../../../components/pc/Home/Dynamic.vue";
import Experience from "../../../components/pc/components/Experience.vue";

import experienceLogo from "../../../assets/home/experienceLogo.png";

export default {
  setup() {
    return reactive({
      experienceLogo: experienceLogo,
      experienceShow: false,
    });
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
  components: {
    TopNav,
    BottomNav,
    HomeBanner,
    System,
    Hardware,
    Software,
    Customer,
    Dynamic,
    Experience,
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .header {
    min-width: 1180px;
  }
}
.header {
  background: rgba(243, 244, 248, 0.4);
  padding-top: 40px;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.logo-position {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .experienceLogo {
    min-width: 1180px;
  }
}
.experienceLogo {
  width: 100%;
  height: 212px;
}
.logo-absolute {
  width: 900px;
  position: absolute;
  top: 20%;
  left: 19%;
}
.logo-absolute .text {
  font-size: 14px;
  color: #fff;
  line-height: 30px;
}
.logo-absolute .click {
  width: 136px;
  margin-top: 30px;
  padding: 12px 0;
  border: 1px solid #ffffff;
  border-radius: 10px 10px 10px 10px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
</style>
